import * as React from 'react';
import NavigationLink from './NavigationLink';
import { ILink } from './Navigation';
import { observer } from 'mobx-react';
import { action } from 'mobx';

export interface INavigationLinksProps<T extends ILink> {
	className?: string;
	links: Array<T>;
	filter?: (link: T) => boolean;
}

const NavigationLinks = observer(<T extends ILink>(props: INavigationLinksProps<T>) => {
	const { className, filter, links } = props;

	const onClick = action((link: ILink) => {
		if (!!link.onClick) {
			link.onClick();
		}
	});

	const htmlLinks = links
		.filter(filter ?? (() => true))
		.filter(link => (link.shouldDisplay ? link.shouldDisplay() : true))
		.map(link => (
			<NavigationLink
				{...link}
				path={link.path}
				label={link.label}
				icon={link.icon}
				iconPos={link.iconPos}
				key={link.path}
				useATag={link.useATag}
				customComponent={link.customComponent}
				isParent={!!link.subLinks}
				onClick={() => onClick(link)}
				isDisabled={link.isDisabled}
				subLinksFilter={link.subLinksFilter}
				className={link.className}
			/>
		));

	return <ul className={className}>{htmlLinks}</ul>;
});

export default NavigationLinks;
